import connect from 'components/Shared/connect';
import styles from './popularCategories.scss';
import { CategoryLink } from 'components/Shared/CategoryLink';
import { NO_ELEMENT } from 'utils';
import { isMobile } from 'components/Shared/responsive';
import { Section } from 'components/Section';
import { Cell, Grid } from 'components/Grid';
import { SectionBlock } from 'models/SectionBlock';
import { PopularCategoriesBlock } from 'models/PopularCategoriesBlock';
import { useDispatch } from 'react-redux';
import { GtmPopularCategoryNavClick } from 'store/googleTagManager/actions';

interface MergedProps extends PopularCategoriesBlock {
  isMobile: boolean;
}

const _PopularCategories = ({ categories, isMobile, ...props }: MergedProps) => {
  const reduxDispatch = useDispatch();
  if (!categories) {
    return NO_ELEMENT;
  }

  const handleClick = (url: string, title: string) => {
    reduxDispatch(GtmPopularCategoryNavClick(url, title));
  };

  return (
    <Section {...props}>
      <Grid
        huge="8"
        desktop="6"
        large="5"
        tablet="4"
        phone="3"
        className={styles.childRemovalWrapper}
      >
        {categories.map(item => (
          <Cell key={item.url}>
            <CategoryLink
              appearance={isMobile ? 'tertiary' : 'primary'}
              title={item.title}
              isPopular={item.showPopularTag}
              categoryUrl={item.url}
              image={item.image}
              handleClick={() => handleClick(item.url, item.title)}
            />
          </Cell>
        ))}
      </Grid>
    </Section>
  );
};

export const PopularCategories = connect<MergedProps, SectionBlock>(state => ({
  isMobile: isMobile(state)
}))(_PopularCategories);
